import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FlyoutFooter } from '../../models/interfaces/footer.models';

@Component({
  selector: 'idp-flyout-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './flyout-footer.component.html',
  styleUrls: ['./flyout-footer.component.scss']
})
export class FlyoutFooterComponent {
  @Input() content: FlyoutFooter = {} as FlyoutFooter;
  @Output() logoutEvent = new EventEmitter();
  @Output() analyticsData = new EventEmitter<Event>();

  onLinkClick(event: Event): void {
    this.analyticsData.emit(event);
  }
}
